// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@conklin/XDL/Utilities";
import translate from "@insite/client-framework/Translate";
import { addToListModalStyles } from "@insite/content-library/Components/AddToListModal";
import { css } from "styled-components";

addToListModalStyles.newListInput = {
    cssOverrides: {
        formField: css`
            margin-top: 15px;
        `,
    },
    placeholder: translate("New Project Name"),
};

addToListModalStyles.buttonsWrapper = {
    css: css`
        margin-top: 30px;
        text-align: right;
        ${xScreen("lte", "xs")} {
            display: flex;
            flex-direction: column-reverse;
            row-gap: 10px;
            button {
                margin: 0;
                width: 100%;
            }
        }
    `,
};

addToListModalStyles.modal = {
    sizeVariant: "small",
};
